import React from "react";
import styled from "styled-components";
import { validateValue, validateAndNormalizeValue } from "../../utils/utils";
import { ModalThumbCut } from "../modal/ModalThumbCut";

const Button = styled.button`
  flex: 1 1 0;
  min-width: 0;
  padding: 6px 10px;
  height: 52px;
  border-radius: 10px;
  background: ${(props) => (props.active === true ? "#E6EAF5" : "#FFFFFF")};
  border: 1px solid #d4d4d5;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #f3f4f6;
  }
`;

const Section = styled.div`
  background: #ffffff;
  opacity: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  width: 100%;
  margin: 6px 0;

  @media (min-width: 768px) and (orientation: portrait) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (min-width: 1440px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

const CellLabel = styled.div`
  flex: 0 0 35%;
  font-size: 14px;
  font-weight: 700;
  color: #00197b;
  text-align: center;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CellValuesCol = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const CellRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
`;

const CellVH = styled.span`
  color: #6b7280;
  font-weight: 600;
`;

const CellValue = styled.span`
  color: #00197b;
  font-weight: 600;
  text-align: right;
`;

// Compact labels for the cut cards: "Back"/"Front" wrap to a second line on
// portrait/narrow layouts, so abbreviate to the first two letters (e.g.
// "1/2 Back" -> "1/2 BA"). The full label is kept in the cut modal header.
const shortenCutLabel = (label) =>
  validateValue(label, "")
    .replace(/\bBack\b/gi, "BA")
    .replace(/\bFront\b/gi, "FR");

export const ThumbCuts = ({
  thumb_cuts,
  specsheetShowThumbcutModal,
  showThumbcutModal,
  isReadOnly,
  flip_vh,
}) => {
  const renderCellContent = (label, v, h) => {
    const vRow = (
      <CellRow>
        <CellVH>V:</CellVH>
        <CellValue>{validateAndNormalizeValue(v, "0.000")}</CellValue>
      </CellRow>
    );
    const hRow = (
      <CellRow>
        <CellVH>H:</CellVH>
        <CellValue>{validateAndNormalizeValue(h, "0.000")}</CellValue>
      </CellRow>
    );
    return (
      <>
        <CellLabel dangerouslySetInnerHTML={{ __html: shortenCutLabel(label) }} />
        <CellValuesCol>
          {flip_vh === "vh" ? (
            <>
              {vRow}
              {hRow}
            </>
          ) : (
            <>
              {hRow}
              {vRow}
            </>
          )}
        </CellValuesCol>
      </>
    );
  };

  return (
    <>
      {thumb_cuts?.length > 0 && (
        <Section>
          {thumb_cuts.map((cut, i) => (
            <Button
              key={cut.id || i}
              name={cut.id || "none"}
              value={cut.id || ""}
              onClick={() =>
                !isReadOnly &&
                specsheetShowThumbcutModal({
                  show: true,
                  thumbcut: cut,
                })
              }
            >
              {renderCellContent(cut.label, cut.v, cut.h)}
            </Button>
          ))}
        </Section>
      )}
      {showThumbcutModal && <ModalThumbCut />}
    </>
  );
};
